import React, { useEffect } from "react";
import { useSpecialism, specialismCodeMap } from "../contexts/SpecialismContext";
import { useAuth } from "../contexts/AuthContext";
import { useHistory } from "react-router-dom";

interface SideMenuProps {
  open: boolean;
  onClose: () => void;
  menuItems: { label: string; onClick: () => void }[];
}

const overlayStyle: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.25)",
  zIndex: 4000,
  transition: "opacity 0.3s",
  display: "flex",
};

const menuStyle: React.CSSProperties = {
  background: "#fff",
  width: 260,
  maxWidth: "80vw",
  height: "100vh",
  boxShadow: "2px 0 16px rgba(0,0,0,0.15)",
  padding: "32px 0 0 0",
  display: "flex",
  flexDirection: "column",
  position: "relative",
  transition: "transform 0.3s cubic-bezier(.4,0,.2,1)",
};

const menuItemStyle: React.CSSProperties = {
  padding: "18px 32px",
  fontSize: "1.1rem",
  color: "#1976d2",
  background: "none",
  border: "none",
  textAlign: "left",
  cursor: "pointer",
  outline: "none",
  borderBottom: "1px solid #f0f0f0",
};

const dropdownLabelStyle: React.CSSProperties = {
  padding: "18px 32px 6px 32px",
  fontSize: "1rem",
  color: "#888",
  background: "none",
  border: "none",
  textAlign: "left",
  outline: "none",
};

const dropdownStyle: React.CSSProperties = {
  margin: "0 32px 18px 32px",
  padding: "8px",
  borderRadius: "8px",
  border: "1px solid #ddd",
  fontSize: "1rem",
  width: "calc(100% - 64px)",
  background: "#f7f7f7",
  color: "#1976d2",
};

const SideMenu: React.FC<SideMenuProps> = ({ open, onClose, menuItems }) => {
  const { specialismCode, setSpecialismCode } = useSpecialism();
  const { user, logout } = useAuth();
  const history = useHistory();

  // Close on ESC
  useEffect(() => {
    if (!open) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, onClose]);

  return (
    <div
      style={{
        ...overlayStyle,
        pointerEvents: open ? "auto" : "none",
        opacity: open ? 1 : 0,
      }}
      onClick={onClose}
    >
      <div
        style={{
          ...menuStyle,
          transform: open ? "translateX(0)" : "translateX(-100%)",
        }}
        onClick={e => e.stopPropagation()}
      >
        <label style={dropdownLabelStyle} htmlFor="side-menu-dropdown">
          Kies specialisme:
        </label>
        <select
          id="side-menu-dropdown"
          style={dropdownStyle}
          value={specialismCode}
          onChange={e => setSpecialismCode(e.target.value as keyof typeof specialismCodeMap)}
        >
          {Object.entries(specialismCodeMap).map(([code, name]) => (
            <option key={code} value={code}>
              {name}
            </option>
          ))}
        </select>

        {menuItems.map((item, idx) => (
          <button
            key={idx}
            style={menuItemStyle}
            onClick={() => {
              item.onClick();
              onClose();
            }}
          >
            {item.label}
          </button>
        ))}
        {/* Add Flashcards button */}
        <button
          style={menuItemStyle}
          onClick={() => {
            history.push("/cards");
            onClose();
          }}
        >
          Flashcards
        </button>

        <div style={{ padding: "16px 32px 0 32px" }}>
          {user ? (
            <button
              style={{
                ...menuItemStyle,
                color: "#d32f2f",
                borderBottom: "none",
                padding: "12px 0",
                width: "100%",
                background: "#fbe9e7",
                marginTop: 12,
              }}
              onClick={() => {
                logout();
                onClose();
              }}
            >
              Log uit
            </button>
          ) : (
            <button
              style={{
                ...menuItemStyle,
                color: "#1976d2",
                borderBottom: "none",
                padding: "12px 0",
                width: "100%",
                background: "#e3f2fd",
                marginTop: 12,
              }}
              onClick={() => {
                history.push("/login");
                onClose();
              }}
            >
              Log in
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SideMenu;